<template>
  <div>
		<div v-if="fetchingArticle && !articleObj" class="w-100 d-flex justify-content-center">
			<b-spinner variant="primary" class="m-3"/>
		</div>
		<b-alert v-else-if="errorArticle" class="mt-5 text-center" variant="danger" show>
			{{errorArticle}}
		</b-alert>
		<div v-else v-html="articleObj.htmlContent" class="ck-content"></div>

    <!-- <b-img src="@/assets/gruppenfoto.jpg"
      class="mb-4 title-image" fluid/>

      <div class="px-4 pb-5">


        <div style="text-align: center" >
          <span>
            Um die erfolgreiche Geschichte unserer Schule fortschreiben zu können, haben sich Jugendliche in der Schülerfirma "JHP-Company", in Trägerschaft des Fördervereins des Gymnasiums, zusammengefunden. Ziel der freiwilligen AG ist der Verkauf und die Vermietung von Schülerarbeiten. Diese sind im Kunstunterricht oder in der Freizeit der Schüler entstanden. Mit den erwirtschafteten Einnahmen werden Projekte der Schule (z.B. die Schülerzeitung "LUX") finanziert. In der Schülerfirma lernen Schüler unter anderem das allgemeine Marktgeschehen und den Umgang mit Finanzmitteln kennen. Außerdem erfahren sie einiges über die allgemeinen Strukturen einer Firma, besonders die einer Genossenschaft, da die AG genossenschaftlich aufgebaut ist. Ein von junge Menschen entworfenes Marketingkonzept soll die Botschaft der "JHP-Company" in die Öffentlichkeit tragen. Wenn Sie Interesse an kreativen Kunstwerken oder Fotos haben und unser Vorhaben unterstützen möchten, sind wir gern für Sie da. Im Sinne von Johann Heinrich Pestalozzi übernehmen wir Verantwortung für unsere Schule und das mit Kopf, Herz und Verstand. Wir stehen Ihnen auch gerne für den Transport und die Montage, gegen Aufpreis, zur Verfügung.
          </span>
        </div>

        <b-row class="mt-5 mx-1" align-h="around">
          <b-col class="embed-responsive embed-responsive-16by9 mb-4 mb-md-0" cols="12" md="5">
            <div v-if="videoAHidden" class="yt-video yt-placeholder embed-responsive-item shadow-sm d-flex align-items-center justify-content-center"
              style="background-image: url('https://img.youtube.com/vi/74Mt5SWWtZk/hqdefault.jpg')"
              @click="videoAHidden = false" >
              <b-icon-play-btn-fill class="h1 mb-0"/>
            </div>
            <iframe v-else class="yt-video embed-responsive-item shadow-sm" src="https://www.youtube.com/embed/74Mt5SWWtZk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </b-col>
          <b-col class="embed-responsive embed-responsive-16by9" cols="12" md="5">
            <div v-if="videoBHidden" class="yt-video yt-placeholder embed-responsive-item shadow-sm d-flex align-items-center justify-content-center"
              style="background-image: url('https://img.youtube.com/vi/GomorqYHz9U/hqdefault.jpg')"
              @click="videoBHidden = false" >
              <b-icon-play-btn-fill class="h1 mb-0"/>
            </div>
            <iframe v-else class="yt-video embed-responsive-item shadow-sm" src="https://www.youtube.com/embed/GomorqYHz9U" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </b-col>
        </b-row> -->
		<div class="px-4 py-5">
			<div v-if="fetchingImages" class="w-100 d-flex justify-content-center">
				<b-spinner variant="primary" class="m-3"/>
			</div>
			<b-alert v-else-if="errorSlideshow" class="mt-5 text-center" variant="danger" show>
				{{errorSlideshow}}
			</b-alert>
			<b-carousel v-else
				:interval="5000" controls indicators 
				class="mt-md-5 mt-4 mx-1 mx-md-5 mb-md-3" >
				<b-carousel-slide v-for="image in slideshowImages" :key="image" 
					class="slideshow-image-container" >
					<template #img>
						<b-img-lazy
							class="d-block img-fluid w-100 rounded"
							:src="image"/>
					</template>
				</b-carousel-slide>
			</b-carousel>
		</div>
	</div>
</template>

<script>
export default {
  data() {
    return {
      slideshowImages: [],
			fetchingArticle: true,
      fetchingImages: true,
      videoAHidden: true,
      videoBHidden: true,
			articleObj: null,
      errorSlideshow: '',
      errorArticle: '',
    }
  },
  mounted() {
		this.articleObj = JSON.parse(localStorage.getItem('homepage')) ?? null;
    this.fetchSlideshowImages();
    this.fetchArticle();
  },
  methods: {
    fetchArticle: async function() {
      this.fetchingArticle = true;
      this.errorArticle = '';

      try {
        let result = await this.axios.get('/api/article', {
          params: {
            special: 'homepage'
          }
        });
				
        this.articleObj = result.data;

				// save cache
				localStorage.setItem('homepage', JSON.stringify(this.articleObj));
      } catch (error) {
        console.log(error);
        this.errorArticle = 'Fehler beim Laden des Artikels';
      }

			if(process.env.NODE_ENV === 'development') {
        this.errorArticle = null;

				// eslint-disable-next-line no-useless-escape
				this.articleObj = {"id":"3","title":"Startseite","year":"-1","visible":true,"publishDate":null,"isSpecial":"homepage","editSource":true,"preview":"\n  .title-image {\n    border-radius: 0.25rem 0.25rem 0rem 0rem !important;\n \t}\n  \n  .yt-video {\n    border-radius: 0.25rem;\n  }\n\n\n\n        \n\n  \n    \n      Um die erfolgreiche Geschichte","htmlContent":"<style type=\"text\/css\" scoped>\n  .title-image {\n    border-radius: 0.25rem 0.25rem 0rem 0rem !important;\n \t}\n  \n  .yt-video {\n    border-radius: 0.25rem;\n  }\n<\/style>\n\n<img src=\"\/images\/articles\/gruppenfoto.jpg\"\n     class=\"mb-4 title-image img-fluid\"\/>\n        \n<div class=\"px-4\">\n  <div style=\"text-align: center\" >\n    <span>\n      Um die erfolgreiche Geschichte unserer Schule fortschreiben zu k\u00f6nnen, haben sich Jugendliche in der Sch\u00fclerfirma \"JHP-Company\", in Tr\u00e4gerschaft des F\u00f6rdervereins des Gymnasiums, zusammengefunden. Ziel der freiwilligen AG ist der Verkauf und die Vermietung von Sch\u00fclerarbeiten. Diese sind im Kunstunterricht oder in der Freizeit der Sch\u00fcler entstanden. Mit den erwirtschafteten Einnahmen werden Projekte der Schule (z.B. die Sch\u00fclerzeitung \"LUX\") finanziert. In der Sch\u00fclerfirma lernen Sch\u00fcler unter anderem das allgemeine Marktgeschehen und den Umgang mit Finanzmitteln kennen. Au\u00dferdem erfahren sie einiges \u00fcber die allgemeinen Strukturen einer Firma, besonders die einer Genossenschaft, da die AG genossenschaftlich aufgebaut ist. Ein von junge Menschen entworfenes Marketingkonzept soll die Botschaft der \"JHP-Company\" in die \u00d6ffentlichkeit tragen. Wenn Sie Interesse an kreativen Kunstwerken oder Fotos haben und unser Vorhaben unterst\u00fctzen m\u00f6chten, sind wir gern f\u00fcr Sie da. Im Sinne von Johann Heinrich Pestalozzi \u00fcbernehmen wir Verantwortung f\u00fcr unsere Schule und das mit Kopf, Herz und Verstand. Wir stehen Ihnen auch gerne f\u00fcr den Transport und die Montage, gegen Aufpreis, zur Verf\u00fcgung.\n    <\/span>\n  <\/div>\n\n  <div class=\"mt-5 mx-1 row justify-content-around\">\n    <div class=\"embed-responsive embed-responsive-16by9 mb-4 mb-md-0 col col-12 col-md-5\">\n      <iframe v-else class=\"yt-video embed-responsive-item shadow-sm\" src=\"https:\/\/www.youtube.com\/embed\/pg3NXnT3kqs\" title=\"YouTube video player\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen><\/iframe>\n    <\/div>\n    <div class=\"embed-responsive embed-responsive-16by9 col col-12 col-md-5\">\n      <iframe v-else class=\"yt-video embed-responsive-item shadow-sm\" src=\"https:\/\/www.youtube.com\/embed\/GomorqYHz9U\" title=\"YouTube video player\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen><\/iframe>\n    <\/div>\n  <\/div>\n<\/div>"}
			}

      this.fetchingArticle = false;
    },
    fetchSlideshowImages: async function() {
      this.fetchingImages = true;
      this.errorSlideshow = '';

      try {
        let result = await this.axios.get('/api/carousel');
        console.log(result);

        this.slideshowImages = result.data ?? [];
      } catch (error) {
        console.log(error);
        this.errorSlideshow = 'Fehler beim Laden der Slideshow. Bitte versuchen Sie es später erneut.';
      }

      this.fetchingImages = false;
    }
  }
}
</script>

<style>
  .carousel-control-prev-icon {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23555' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e") !important;
  }

  .carousel-control-next-icon {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23555' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e") !important;
  }

  /* Stuff to have a "responsive fixed" height for all slideshow images */
  .slideshow-image-container {
   position: relative;
   width: 100%;
   padding-top: 56.25%; /* 16:9 Aspect Ratio */
  }

  .carousel-item img {
    width: auto !important;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: block;
    margin: auto;
    border-radius: 0.25rem;
  }

  .yt-placeholder {
    background-position: center; 
    background-size: cover; 
    cursor: pointer;
    color: gray;
    transition: 0.2s;
  }

  .yt-placeholder:hover {
    color: lightgray;
  }
</style>